import { Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-token-generate-v2',
  templateUrl: './dialog-token-generate-v2.component.html',
  styleUrls: ['./dialog-token-generate-v2.component.sass']
})
export class DialogTokenGenerateV2Component implements OnInit {
  model: any = {
    label: '',
    type: 'PROGRAM',
    scopes: [],
    ttl: null
  };

  types = [
    { value: 'PROGRAM', label: 'Program' },
    { value: 'MERCHANT', label: 'Merchant' }
  ];

  availableScopes = [
    'PERKS',
    'LOYALTIES',
    'TX_INJECTION',
    'ALL'
  ];

  constructor(
    public dialogRef: MatDialogRef<DialogTokenGenerateV2Component>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {}

  onScopeToggle(scope: string, event: any) {
    if (event.target.checked) {
      this.model.scopes = [ ...this.model.scopes, scope ];
    } else {
      this.model.scopes = this.model.scopes.filter(s => s !== scope);
    }
  }

  canConfirm() {
    return this.model.label.trim().length > 0 && this.model.scopes.length > 0;
  }

  onConfirm() {
    if (!this.canConfirm()) { return; }

    this.dialogRef.close(this.model);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
